import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/index'
import Lipei from '@/pages/lipei'
import Pilu from '@/pages/pilu'

Vue.use(Router)

export default new Router({

  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/lipei',
      name: 'Lipei',
      component: Lipei
    },
    {
      path: '/pilu',
      name: 'Pilu',
      component: Pilu
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js